import { Link } from 'react-router-dom'
import { StatCardProps } from '@/ui/props.js'

/**
 * A panel showing a large number with a label, optional breakdown, and optional
 * top-right metadata. When `to` is provided, wraps in a React Router Link for
 * proper middle-click and new-tab support.
 */
export function StatCard({ label, value, breakdown, meta, to, className = '' }: StatCardProps) {
  const panel = (
    <div
      className={[
        'bg-surface-container border border-outline-variant rounded-lg p-5',
        'transition-all interactive',
        'flex flex-col h-full',
        to && 'hover:border-outline hover:bg-surface-high',
        to && 'focus-visible:outline-2 focus-visible:outline-offset-2',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="space-y-2">
        {/* Top row: label left, optional meta right */}
        <div className="flex items-baseline justify-between gap-4">
          <div className="text-label-md text-on-surface-variant">{label}</div>
          {meta && <div className="text-label-sm text-on-surface-subtle">{meta}</div>}
        </div>
        {/* Value, large and prominent */}
        <div className="text-figure-lg text-on-surface tabular">{value}</div>
      </div>
      {/* Breakdown pushed to bottom to reserve its height across all cards in a row */}
      {breakdown && (
        <div className="text-body-sm text-on-surface-variant mt-auto pt-2">
          {breakdown}
        </div>
      )}
    </div>
  )

  if (to) {
    return (
      <Link to={to} className="h-full">
        {panel}
      </Link>
    )
  }

  return panel
}
